import {Mapper} from '@s-ui/domain'

export class SeoAdsListSemanticEnvironmentalLabelMetaConfigMapper extends Mapper {
  #config
  #seoConfig

  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * */
  static create({config}) {
    return new SeoAdsListSemanticEnvironmentalLabelMetaConfigMapper({config})
  }

  constructor({config}) {
    super()
    this.#config = config
    this.#seoConfig = this.#config.get('seo')
  }

  #getAdsListSemanticConfigKey = ({environmentalLabelValue}) => {
    const {ENVIRONMENTAL_LABELS_ECO_ID, ENVIRONMENTAL_LABELS_0_ID} = this.#config.get('search')

    if (!environmentalLabelValue) return 'default'
    if (environmentalLabelValue === ENVIRONMENTAL_LABELS_ECO_ID) return 'eco'
    if (environmentalLabelValue === ENVIRONMENTAL_LABELS_0_ID) return 'cero'

    return 'default'
  }

  map = ({adsListSemanticConfig, params: {environmentalLabelValue}}) => {
    const adsListSemanticConfigKey = this.#getAdsListSemanticConfigKey({
      environmentalLabelValue
    })

    return adsListSemanticConfig[adsListSemanticConfigKey]
  }
}
